import React from 'react';
import '../styles/Contact.css';

const Contact = () => {
  return (
    <div className="contact-container">
      <div className="contact-content">
        <header className="contact-header">
          <h1 className="contact-title">Contact</h1>
          <p className="contact-subtitle">Get in touch</p>
        </header>
      
      
      
        <div classname="contact-super" style={{display: "flex", flexWrap:"wrap"}}>



        <div className="contact-form-container">
          <div className="contact-card">
            <div className="contact-info">
              <div className="contact-section">
                <h3 className="section-title">Email Address</h3>
                <div className="contact-field">
                  <input 
                    type="email" 
                    className="contact-input"
                    value="arulshambhasin@arulshambhasin.com"
                    disabled
                  />
                </div>
              </div>

              <div className="contact-section">
                <h3 className="section-title"></h3>
                <div className="contact-field">
                  <textarea 
                    className="contact-textarea" 
                    placeholder="If its an official matter including research, collaborations and business inquiries"
                    rows="1"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </div>



         <div className="contact-form-container">
          <div className="contact-card">
            <div className="contact-info">
              <div className="contact-section">
                <h3 className="section-title">Email Address</h3>
                <div className="contact-field">
                  <input 
                    type="email" 
                    className="contact-input"
                    value="arul@arulshambhasin.com"
                    disabled
                  />
                </div>
              </div>

              <div className="contact-section">
                <h3 className="section-title"></h3>
                <div className="contact-field">
                  <textarea 
                    className="contact-textarea" 
                    placeholder="Informal Stuff"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </div>




        <div className="contact-form-container">
          <div className="contact-card">
            <div className="contact-info">
              <div className="contact-section">
                <h3 className="section-title">Email Address</h3>
                <div className="contact-field">
                  <input 
                    type="email" 
                    className="contact-input"
                    value="sae.uiet.pu@arulshambhasin.com"
                    disabled
                  />
                </div>
              </div>

              <div className="contact-section">
                <h3 className="section-title"></h3>
                <div className="contact-field">
                  <textarea 
                    className="contact-textarea" 
                    placeholder="Students of SAE UIET PU use this address. Chairpersons may also reach out via the Chairperson Network"
                    rows="1"
                    disabled
                  />
                </div>
                </div>
              </div>
            </div>
          </div>
        

            {/* Email 4 */}
           {/* <div className="contact-form-container">
          <div className="contact-card">
            <div className="contact-info">
              <div className="contact-section">
                <h3 className="section-title">Email Address</h3>
                <div className="contact-field">
                  <input 
                    type="email" 
                    className="contact-input"
                    value="arulshambhasin@gmail.com"
                    disabled
                  />
                </div>
              </div>

              <div className="contact-section">
                <h3 className="section-title"></h3>
                <div className="contact-field">
                  <textarea 
                    className="contact-textarea" 
                    placeholder="If the matter is urgent and you’ve already sent an email without receiving a response."
                    rows="1"
                    disabled
                  />
                </div>
                </div>
              </div>
            </div>
          </div>
         */}





        {/* Email 5 */}
         {/* <div className="contact-form-container">
          <div className="contact-card">
            <div className="contact-info">
              <div className="contact-section">
                <h3 className="section-title">Email Address</h3>
                <div className="contact-field">
                  <input 
                    type="email" 
                    className="contact-input"
                    value="arulshambhasin@arulshambhasin.com"
                    disabled
                  />
                </div>
              </div>

              <div className="contact-section">
                <h3 className="section-title"></h3>
                <div className="contact-field">
                  <textarea 
                    className="contact-textarea" 
                    placeholder="If its an official matter including research, collaborations and business inquiries"
                    rows="1"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </div> */}





        
        </div>
        
         <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'transparent' // optional background
    }}>   
        <p className="contact-subtitle2">You can use the form below as well</p>
     </div>
     
     
     <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100%',
      backgroundColor: 'transparent' // optional background
    }}>
      <iframe
        src="https://app.formbricks.com/s/cmct6a89lpbloxz0190ryy532?embed=true"
        style={{
          width: '100%',
          maxWidth: '500px',
          height: '300px',
          border: 'none',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}
        title="Contact Form"
      />
    </div>



      </div>
    </div>

  );
  
};

export default Contact;